import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { extractErrorMessage, useStore } from "../../../helpers";
import { TARS_FACETS_CREATE_PATH } from "../tars-constants";
import { markTarsNotebookActivity } from "./useGetNotebooks";

export interface CreateFacetPayload {
  notebook_id: number;
  source_id: number;
  canvas_id: number;
  etl_json: Record<string, unknown>;
  facet_result: Record<string, unknown>;
  version: number;
  more: Record<string, unknown>;
}

export const useCreateFacet = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateFacetPayload) => {
      const res = await rootStore.apiRequestHandler(
        TARS_FACETS_CREATE_PATH,
        payload,
        "Failed to create facet"
      );
      return res.data ?? res;
    },
    onSuccess: (_data, variables) => {
      markTarsNotebookActivity(queryClient, variables.notebook_id);
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to create facet"));
    },
  });
};
